var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-24", attrs: { id: "client-tags" } }, [
    _c("div", { staticClass: "py-10 flex justify-center" }, [
      _c(
        "div",
        {
          staticClass:
            "relative w-180 h-min py-5 bg-pure-white border border-slate-400 rounded-3xl",
          attrs: { id: "tags-card" }
        },
        [
          _c(
            "div",
            {
              staticClass: "py-5 px-10 space-y-4 border-b border-slate-400",
              attrs: { id: "tags-header" }
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-col gap-2" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlTextTitle3", { attrs: { text: "Clients" } }),
                      _vm._v(" "),
                      _c("BlBubbleCount", {
                        attrs: { count: _vm.totalLabels || 0 }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Create tags to provide additional information for the clients."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentUser.role.includes("admin")
                ? _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.tagInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          icon: "plus",
                          label: "Create",
                          loading: _vm.submitLoading,
                          disabled: !_vm.tagInput.model
                        },
                        on: { clicked: _vm.onCreate }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-5 px-10 space-y-2", attrs: { id: "tags-body" } },
            [
              _c(
                "div",
                { staticClass: "grid grid-cols-5" },
                [
                  _c("BlSort", {
                    staticClass: "col-span-2",
                    attrs: {
                      options: _vm.sortOptions,
                      defaultValue: { primary: "date", secondary: "desc" }
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChangeSort($event)
                      }
                    },
                    model: {
                      value: _vm.sortInput,
                      callback: function($$v) {
                        _vm.sortInput = $$v
                      },
                      expression: "sortInput"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.pageLoading
                ? _c("div", { staticClass: "h-128 grid place-items-center" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : !_vm.labels.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "h-128 flex flex-col items-center justify-center gap-6"
                    },
                    [
                      _c("BlIcon", { attrs: { icon: "tags-empty" } }),
                      _vm._v(" "),
                      _c("BlTextBody1", {
                        staticClass: "text-center",
                        attrs: {
                          text:
                            "Don't see any tags yet? No problem! They'll start appearing as soon as you create a new tag."
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    _vm._l(_vm.labels, function(label) {
                      return _c("TagItem", {
                        key: label.id,
                        attrs: { label: label }
                      })
                    }),
                    1
                  )
            ]
          ),
          _vm._v(" "),
          _vm.totalLabels > 25
            ? _c(
                "div",
                { staticClass: "py-5 px-10", attrs: { id: "tags-footer" } },
                [
                  _c("BlInputPagination", {
                    attrs: {
                      page: _vm.page,
                      perPage: _vm.perPage,
                      total: _vm.totalLabels
                    },
                    on: {
                      changed: _vm.changePage,
                      "changed-per-page": _vm.changePerPage
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f232d25", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f232d25","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/tags/ClientTags.vue
// module id = null
// module chunks = 